import Collection from './collection';
import React from 'react';
import PropTypes from 'prop-types';
import Tr from './tr';

//
// Set of allowed child Components for the Table Body.
//
const COMPONENTS = {
  tr: Tr
};

/**
 * A table footer component
 *
 * @displayName Tfoot
 * @export
 * @class Tfoot
 * @extends {Collection}
 */
export default class Tfoot extends Collection {
  /**
   * Getter that returns the allowed children.
   *
   * @returns {Object} Components
   * @private
   */
  get components() {
    return COMPONENTS;
  }

  /**
   * Render a table footer.
   *
   * @returns {ReactElement} Table footer.
   * @public
   */
  render() {
    const { style, children, className } = this.props;
    return <tfoot style={ style } className={ className }>
      { React.Children.map(children, this.renderChildren, this) }
    </tfoot>;
  }
}

Tfoot.propTypes = {
  /** Child row */
  children: PropTypes.node,
  /** Styles to apply to the element */
  style: PropTypes.object,
  /** ClassName to apply to the element */
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./node_modules/@ux/table/tfoot.js